// import React from 'react'
// import getIcon from '../../utils/getIcon'

// const Input = ({ label, icon, type = "text", placeholder, labelId, name, centerLink }) => {
//     return (
//         <div className="row mb-4 align-items-center">
//             <div className="col-lg-2">
//                 <label htmlFor={labelId} className="fw-semibold">{label}: </label>
//             </div>
//             <div className="col-lg-2">
//                 <div className="input-group">
//                     <div className="input-group-text">{getIcon(icon)}</div>
//                     {centerLink ? <div className="input-group-text">https://themeforest.net/user/theme_ocean</div> : ""}
//                     <input type={type} name={name} className="form-control" id={labelId} placeholder={placeholder} />
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Input

// import React from 'react';
// import getIcon from '../../utils/getIcon';

// const Input = ({
//   label,
//   icon,
//   type = 'text',
//   placeholder,
//   labelId,
//   name,
//   value,
//   onChange,
//   centerLink
// }) => {
//   return (
//     <div className="row mb-4 align-items-center">
//       <div className="col-lg-2">
//         <label htmlFor={labelId} className="fw-semibold">
//           {label}:
//         </label>
//       </div>
//       <div className="col-lg-4">
//         <div className="input-group">
//           <div className="input-group-text">{getIcon(icon)}</div>
//           {centerLink ? (
//             <div className="input-group-text"></div>
//           ) : (
//             ''
//           )}
//           <input
//             type={type}
//             name={name}
//             className="form-control"
//             id={labelId}
//             placeholder={placeholder}
//             value={type === 'checkbox' ? undefined : value}
//             checked={type === 'checkbox' ? value : undefined}
//             onChange={onChange}
//             maxLength={['phone', 'contact', 'whatsapp', 'alternate_contact'].includes(name) ? 10 : undefined}
//             minLength={['phone', 'contact', 'whatsapp', 'alternate_contact'].includes(name) ? 10 : undefined}
//             onKeyPress={['phone', 'contact', 'whatsapp', 'alternate_contact'].includes(name) ? (e) => {
//               if (!/^[0-9]$/.test(e.key)) e.preventDefault();
//             } : undefined}
//             onPaste={['phone', 'contact'].includes(name) ? (e) => e.preventDefault() : undefined}
//           />

//           {/* <input
//             type={type}
//             name={name}
//             className="form-control"
//             id={labelId}
//             placeholder={placeholder}
//             value={value}
//             onChange={onChange}
//             maxLength={name === 'phone' || name === 'contact' || name === 'whatsapp' || name === 'alternate_contact' ? 10 : undefined}
//             minLength={name === 'phone' || name === 'contact' || name === 'whatsapp' || name === 'alternate_contact' ? 10 : undefined}
//             onKeyPress={name === 'phone' || name === 'contact' || name === 'whatsapp' || name === 'alternate_contact' ? (e) => {
//               if (!/^[0-9]$/.test(e.key)) e.preventDefault();
//             } : undefined}
//             onPaste={name === 'phone' || name === 'contact' ? (e) => e.preventDefault() : undefined}
//           /> */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Input;

import React from "react";
import getIcon from "../../utils/getIcon";

const Input = ({
  label,
  icon,
  type = "text",
  placeholder,
  labelId,
  name,
  value,
  onChange,
  required = false,
  centerLink,
}) => {
  const handleCheckboxChange = (e) => {
    onChange(name, e.target.checked); // Pass only the name and checked value
  };

  return (
    <div className="row mb-4 align-items-center">
      <div className="col-lg-2">
        <label htmlFor={labelId} className="fw-semibold">
          {`${label || ""}:`}
          {required && <span style={{ color: "red" }}> *</span>}
        </label>
      </div>

      <div className="col-lg-6">
        {type === "checkbox" ? (
          <div className="form-check">
            <input
              type="checkbox"
              name={name}
              id={labelId}
              className="form-check-input"
              checked={value} // Bind the checked state to the value
              onChange={handleCheckboxChange} // Update the state on change
            />
            <label htmlFor={labelId} className="fw-semibold">
              {`${label || ""}:`}
              {required && <span style={{ color: "red" }}> *</span>}
            </label>
          </div>
        ) : (
          <div className="input-group">
            <div className="input-group-text">{getIcon(icon)}</div>
            {centerLink ? <div className="input-group-text"></div> : ""}
            <input
              type={type}
              name={name}
              className="form-control"
              id={labelId}
              required={required}
              placeholder={placeholder}
              value={type !== "file" ? value : undefined}
              onChange={(e) => {
                if (type === "file") {
                  onChange(e); // Pass the full event for file input
                } else {
                  onChange(name, e.target.value);
                }
              }}
              min={
                (type === "date" || type === "datetime-local") &&
                name === "follow_up_datetime"
                  ? type === "datetime-local"
                    ? new Date().toISOString().slice(0, 16)
                    : new Date().toISOString().split("T")[0]
                  : undefined
              }
              maxLength={
                [
                  "phone",
                  "contact",
                  "payouts",
                  "whatsapp",
                  "refrence_mobile",
                  "alternate_contact",
                  "phone_number",
                  "alternate_number",
                ].includes(name)
                  ? 10
                  : undefined
              }
              minLength={
                [
                  "phone",
                  "contact",
                  "whatsapp",
                  "refrence_mobile",
                  "alternate_contact",
                  "phone_number",
                  "alternate_number",
                ].includes(name)
                  ? 10
                  : undefined
              }
              onKeyPress={
                [
                  "phone",
                  "contact",
                  "payouts",
                  "whatsapp",
                  "refrence_mobile",
                  "alternate_contact",
                  "phone_number",
                  "alternate_number",
                ].includes(name)
                  ? (e) => {
                      if (!/^[0-9]$/.test(e.key)) e.preventDefault();
                    }
                  : undefined
              }
              onPaste={
                ["phone", "contact"].includes(name)
                  ? (e) => e.preventDefault()
                  : undefined
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Input;
